class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.button = this.querySelector('button');
    this.handlePlayPause = this.handlePlayPause.bind(this);
  }

  connectedCallback() {
    if (this.button) {
      this.button.addEventListener('click', this.handlePlayPause);
    }

    this.video.addEventListener('pause', () => {
      this.button.style.display = 'block';
    });

    this.video.addEventListener('play', () => {
      this.button.style.display = 'none';
      this.video.controls = true;
    });

    this.video.addEventListener('ended', () => {
      this.button.style.display = 'block';
      this.video.controls = false;
    });
  }

  handlePlayPause() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }
}

customElements.define('custom-video', CustomVideo);
